import React from 'react';
import { Platform, Text, View } from 'react-native';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export var Tag = function Tag(props) {
  var block = props.block,
    color = props.color,
    _props$maxLines = props.maxLines,
    maxLines = _props$maxLines === void 0 ? 1 : _props$maxLines,
    propStyles = props.styles;
  return block ? /*#__PURE__*/React.createElement(View, {
    style: [styles.container, propStyles === null || propStyles === void 0 ? void 0 : propStyles.container, color != null && {
      backgroundColor: color
    }]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.text, propStyles === null || propStyles === void 0 ? void 0 : propStyles.text],
    numberOfLines: maxLines
  }, props.children)) : /*#__PURE__*/React.createElement(Text, {
    style: [styles.container, styles.text, propStyles === null || propStyles === void 0 ? void 0 : propStyles.text, color != null && {
      backgroundColor: color
    }],
    numberOfLines: maxLines
  }, props.children);
};
var fontBold = Platform.select({
  ios: '500',
  android: 'bold'
}) || '500';
var styles = CustomStyleSheet({
  container: {
    paddingHorizontal: 4,
    paddingVertical: 2,
    borderRadius: 1,
    backgroundColor: '#30b566'
  },
  text: {
    lineHeight: 16 * 1.2,
    fontWeight: fontBold,
    fontSize: 10,
    color: '#ffffff'
  }
});